import React, { ReactElement } from "react"
import { TextField, IconButton } from "material-ui"
import Clear from "../../components/misc/Clear"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import Sync from "material-ui/svg-icons/notification/system-update"
import Copy from "../../../assets/icons/copy"

interface IProps {
	rowSelectionCount?: number
	searchText?: string
	searchTextFieldWidth?: string
	title?: string
	multipleSelectedMessage?: string
	singleSelectedMessage?: string
	readonly?: boolean
	titleStyle?: React.CSSProperties
	bodyStyle?: React.CSSProperties
	customActionElement?: ReactElement
	onSearch?(searchText: string, cb?: any): void
	onCloseSearchClick?(): void
	onDeleteClick?(): void
	onSearchClick?(): void
	onEditSelectedItem?(): void
	onAssignSelectedItem?(): void
	onDeclineSelectedItem?(): void
	reloadTable?(): void
	exportTable?(): void
	onSyncClick?(): void
	onCopyClick?(): void
}
interface IState {
	actionsVisibility?: boolean
	headerVisibility?: boolean
	searchVisibility?: boolean
	searchText?: string
	search?: boolean
	searchFieldCanFocus?: boolean
	editIconTooltipVisibility?: boolean
}

export default class TableActionBar extends React.Component<IProps, IState>  {
	private searchField
	constructor(props) {
		super(props)
		this.state = {
			actionsVisibility: this.getActionsBarVisibility(props),
			headerVisibility: this.getHeaderBarVisibility(props),
			searchVisibility: this.getSearchBarVisibility(props),
			searchText: props.searchText || "",
			search: props.searchText.length > 0,
			searchFieldCanFocus: true,
			editIconTooltipVisibility: false
		}
		autobind(this)
	}

	componentDidMount() {
		this.getSearchBarVisibility(this.props) && this.searchField.focus()
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			actionsVisibility: this.getActionsBarVisibility(nextProps),
			headerVisibility: this.getHeaderBarVisibility(nextProps),
			searchVisibility: this.getSearchBarVisibility(nextProps)
		}, () =>
			this.getSearchBarVisibility(nextProps) &&
			this.state.searchFieldCanFocus &&
			this.searchField.focus()
		)
	}

	getActionsBarVisibility(props) {
		if (typeof this.state === "undefined") {
			this.state = { search: false }
		}
		const showActions = props.rowSelectionCount > 0
		return showActions
	}

	getHeaderBarVisibility(props) {
		if (typeof this.state === "undefined") {
			this.state = { search: false }
		}
		const showActions = props.rowSelectionCount > 0
		return !(showActions || this.state.search)
	}

	getSearchBarVisibility(props) {
		if (typeof this.state === "undefined") {
			this.state = { search: false }
		}
		return this.state.search
	}

	onSearchClick() {
		this.setState({ search: true }, () =>
			this.setState({
				actionsVisibility: this.getActionsBarVisibility(this.props),
				headerVisibility: this.getHeaderBarVisibility(this.props),
				searchVisibility: this.getSearchBarVisibility(this.props)
			}, () => {
				this.searchField.focus()
				this.props.onSearchClick && this.props.onSearchClick()
			})
		)
	}

	onCloseSearchClick() {
		this.props.onSearch("")
		this.setState({ search: false }, () =>
			this.setState({
				actionsVisibility: this.getActionsBarVisibility(this.props),
				headerVisibility: this.getHeaderBarVisibility(this.props),
				searchVisibility: this.getSearchBarVisibility(this.props),
				searchText: ""
			})
		)
		this.props.onCloseSearchClick &&
			this.props.onCloseSearchClick()
	}

	render() {
		const titleStyle = (this.props.titleStyle ? this.props.titleStyle : { fontSize: 25, fontWeight: "bold" }) as React.CSSProperties
		const bodyStyle = this.props.bodyStyle ? this.props.bodyStyle : { padding: 20, paddingLeft: 35 }
		return (
			<div className="TableActionBar">
				{this.state.headerVisibility &&
					<div style={{ height: 60 }}>
						<div style={bodyStyle}>
							<span style={titleStyle}>{this.props.title}</span>
							<div style={{ float: "right" }}>
								<div style={{ display: "flex", flexDirection: "row", verticalAlign: "middle" }}>
									{this.props.onSearch &&
										<div title={strings.Search}>
											<i
												data-intercom-target={`menu-${this.props.title && this.props.title.includes(" ") ? this.props.title.split(" ").join("-") : this.props.title}-Table-Search`}
												className="fa fa-search itemActionButton"
												style={{ fontSize: 25 }}
												onClick={this.onSearchClick}
											/>
										</div>
									}
									{this.props.reloadTable &&
										<div
											data-intercom-target={`menu-${this.props.title && this.props.title.includes(" ") ? this.props.title.split(" ").join("-") : this.props.title}-Table-Reload`}
											title={strings.Refresh}
											style={{ marginLeft: "20px" }}
											onClick={this.props.reloadTable}
										>
											<i style={{ fontSize: 25 }} className="fa fa-refresh itemActionButton" />
										</div>
									}
									{this.props.exportTable &&
										<div
											title={strings.Export}
											style={{ marginLeft: "20px" }}
											onClick={this.props.exportTable}
										>
											<i style={{ fontSize: 25 }} className="fa fa-download itemActionButton" />
										</div>
									}
									{this.props.customActionElement &&
										React.cloneElement(this.props.customActionElement)
									}
								</div>
							</div>
							<Clear />
						</div>
					</div>
				}
				{this.state.actionsVisibility &&
					<div style={{ height: 60 }}>
						<div style={{ background: "#cccccc", padding: 20, paddingLeft: 35 }}>
							<span style={{ fontSize: 25, fontWeight: 200 }}>
								{this.props.rowSelectionCount > 1 ? strings.formatString(this.props.multipleSelectedMessage, this.props.rowSelectionCount) : this.props.singleSelectedMessage}
							</span>
							<div style={{ float: "right", display: "flex" }}>
								{this.props.onAssignSelectedItem &&
									<i
										className="fa fa-check itemActionButton"
										title={strings.Assign_Employee}
										onClick={this.props.onAssignSelectedItem}
										style={{ fontSize: 25 }}
									/>
								}
								{this.props.onDeclineSelectedItem &&
									<i
										className="fa fa-ban itemActionButton"
										title={strings.Decline}
										onClick={this.props.onDeclineSelectedItem}
										style={{ fontSize: 25 }}
									/>
								}
								{!this.props.readonly && this.props.onEditSelectedItem &&
									<i
										className="fa fa-edit itemActionButton"
										id="editIconTooltip"
										onMouseEnter={() => this.setState({ editIconTooltipVisibility: true })}
										onMouseLeave={() => this.setState({ editIconTooltipVisibility: false })}
										onClick={this.props.onEditSelectedItem}
										style={{ fontSize: 25, marginLeft: 20 }}
									/>
								}
								{this.props.onSyncClick &&
									<IconButton
										data-intercom-target={"menu-Btn-Force-Device-Sync"}
										tooltip={strings.Init_Devices}
										tooltipPosition="bottom-center"
										style={{ padding: 0, width: 20, height: 0 }}
										onClick={this.props.onSyncClick}
									>
										<Sync />
									</IconButton>
								}
								{this.props.onCopyClick &&
									<IconButton
										onClick={this.props.onCopyClick}
										style={{ padding: 0, height: 25, width: 25 }}
									>
										<Copy width={23} height={20} color="rgb(97, 97, 97)" />
									</IconButton>
								}
								{!this.props.readonly && this.props.onDeleteClick &&
									<i
										className="fa fa-trash itemActionButton"
										onClick={() => this.props.onDeleteClick()}
										style={{ fontSize: 25, marginLeft: 20 }}
									/>
								}
							</div>
						</div>
					</div>
				}
				{this.state.searchVisibility &&
					<div style={{ height: 60 }}>
						<div style={bodyStyle}>
							<i style={{ fontSize: 25, cursor: "pointer" }} className="fa fa-search" onClick={() => this.searchField.focus()} />
							<TextField
								data-intercom-target={`menu-${this.props.title && this.props.title.includes(" ") ? this.props.title.split(" ").join("-") : this.props.title}-Table-Search-Entry`}
								hintText={strings.search}
								value={this.state.searchText}
								onChange={e => {
									this.props.onSearch(e.target.value, () => this.searchField.focus())
									this.setState({ searchText: e.target.value })
								}}
								onKeyUp={event => {
									(event.keyCode === 13 || event.keyCode === 27) &&
										this.onCloseSearchClick()
								}}
								style={{ marginRight: 20, width: this.props.searchTextFieldWidth ? this.props.searchTextFieldWidth : "85%", marginLeft: 15 }}
								ref={item => this.searchField = item}
							/>
							<div style={{ float: "right", verticalAlign: "center" }}>
								<i
									data-intercom-target={`menu-${this.props.title && this.props.title.includes(" ") ? this.props.title.split(" ").join("-") : this.props.title}-Table-Search-Close`}
									className="fa fa-close itemActionButton"
									style={{ fontSize: 25 }}
									onClick={this.onCloseSearchClick}
								/>
							</div>
							<Clear />
						</div>
					</div>
				}
			</div>
		)
	}
}
